/* 97Hz Mobile - AJAX thêm giỏ + badge + bottom sheet "Đã thêm vào giỏ" */
(function () {
  if (window.__mb97Init) return;
  window.__mb97Init = true;

  function updateBadges(count) {
    document.querySelectorAll('.mb97-cart-count').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  function formatVND(cents) {
    try {
      return new Intl.NumberFormat('vi-VN').format(Math.round(cents / 100)) + '₫';
    } catch (e) {
      return Math.round(cents / 100) + '₫';
    }
  }

  var sheet, scrim;
  function buildSheet() {
    if (sheet) return;
    scrim = document.createElement('div');
    scrim.className = 'mb97-sheet-scrim';
    sheet = document.createElement('div');
    sheet.className = 'mb97-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-label', 'Đã thêm vào giỏ');
    sheet.innerHTML =
      '<div class="mb97-sheet__check">' +
      '<svg width="26" height="26" viewBox="0 0 20 20" fill="none"><path d="M3 10L8 15L17 5" stroke="#000E8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>' +
      '<div class="mb97-sheet__title">Đã thêm vào giỏ</div>' +
      '<div class="mb97-sheet__item" data-mb97-sheet-name></div>' +
      '<div class="mb97-sheet__price" data-mb97-sheet-price></div>' +
      '<a class="mb97-sheet__checkout" href="/checkout">Thanh toán ngay</a>' +
      '<button class="mb97-sheet__continue" type="button">Tiếp tục xem</button>';
    document.body.appendChild(scrim);
    document.body.appendChild(sheet);
    scrim.addEventListener('click', closeSheet);
    sheet.querySelector('.mb97-sheet__continue').addEventListener('click', closeSheet);
  }

  function openSheet(name, priceCents) {
    buildSheet();
    sheet.querySelector('[data-mb97-sheet-name]').textContent = name || '';
    sheet.querySelector('[data-mb97-sheet-price]').textContent = priceCents != null ? formatVND(priceCents) : '';
    requestAnimationFrame(function () {
      scrim.classList.add('mb97-sheet-scrim--open');
      sheet.classList.add('mb97-sheet--open');
    });
  }

  function closeSheet() {
    if (!sheet) return;
    scrim.classList.remove('mb97-sheet-scrim--open');
    sheet.classList.remove('mb97-sheet--open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.mb97-atc-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (added) {
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateBadges(cart.item_count);
            openSheet(added.product_title || added.title, added.final_price != null ? added.final_price : added.price);
          });
      })
      .catch(function () {
        // fallback: submit thường (điều hướng về trang giỏ hàng)
        form.submit();
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  });

  /* ---- 97Hz · Nút "Mua ngay" standalone (desktop): thêm giỏ rồi vào thẳng /checkout ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mb97-buynow]');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var formSelector = btn.getAttribute('data-mb97-buynow');
    var form = formSelector ? document.querySelector(formSelector) : null;
    var input = form ? form.querySelector('input[name="id"], select[name="id"]') : null;
    var variantId = input ? input.value : null;

    if (!variantId) {
      window.location.href = '/checkout';
      return;
    }

    btn.disabled = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  });

  /* ---- 97Hz · Nút "Trả góp qua thẻ" mở đúng popup của khối mb-97hz-installment sẵn có ---- */
  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-mb97-trigger-installment]');
    if (!trig) return;
    var uid = trig.getAttribute('data-mb97-trigger-installment');
    var box = uid ? document.getElementById(uid) : null;
    var opener = box ? box.querySelector('[data-mb97ins-open]') : null;
    if (opener) {
      opener.click();
    } else if (box) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---- 97Hz · Modal thông tin trả góp (mở/đóng, dùng chung mobile + desktop) ---- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mb97-modal-open]');
    if (opener) {
      var sel = opener.getAttribute('data-mb97-modal-open');
      var modal = sel ? document.querySelector(sel) : null;
      if (modal) {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
      }
      return;
    }
    var closer = e.target.closest('[data-mb97-modal-close]');
    if (closer) {
      var modalToClose = closer.closest('.mb97-modal');
      if (modalToClose) {
        modalToClose.classList.remove('is-open');
        modalToClose.setAttribute('aria-hidden', 'true');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.mb97-modal.is-open').forEach(function (m) {
      m.classList.remove('is-open');
      m.setAttribute('aria-hidden', 'true');
    });
  });
})();